import { noticeError, sanitizeAttributes } from 'modules/core/monitoring';

type StructuredError = {
	name: string;
	message: string;
	extra?: Record<string, unknown>;
};

type ErrorLoggerInput = Error | StructuredError;

const errorLogger = (input: ErrorLoggerInput): void => {
	if (input instanceof Error) {
		noticeError(input);
		return;
	}

	const err = new Error(input.message);
	err.name = input.name;

	const attributes = sanitizeAttributes(input.extra);
	if (Object.keys(attributes).length === 0) {
		noticeError(err);
		return;
	}
	noticeError(err, attributes);
};

export default errorLogger;
